module.exports = __webpack_public_path__ + "img/consuelo.3e07c8dd.jpg";